// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"521":"8fd7545bb6fa8850","778":"c4f355e7fc8d4512"}[chunkId] + ".js";
};